import ResetPassword from 'routes/public/ResetPassword'

export default ResetPassword
